import createReducer from './../lib/createReducer';
import * as types from './../actions/types';
import moment from 'moment';

export const Outreaches = createReducer({
  outreaches: [],
}, {
  [types.GET_OUTREACHES_START](state) {
    const newState = Object.assign({}, state, {
        getOutreach:true
    });

    return newState;
  },
  [types.GET_OUTREACHES_FAIL](state) {
    const newState = Object.assign({}, state, {
        getOutreach:false,
        outreaches:{}
    });

    return newState;
  },
  [types.GET_OUTREACHES_SUCCESS](state,actions) {
    const newState = Object.assign({}, state, {
        getOutreach:false,
        outreaches:actions.outreaches
    });

    return newState;
  },
  [types.SAVE_OUTREACH_NAME](state,actions){
    const newState = Object.assign({},state,{
        outreachname:actions.name,
        campaign:[]
    });
    return newState;
  },
  [types.GET_CAMPAIGN_START](state){
    const newState = Object.assign({},state,{
        getCampaign:true,
        fileuploaded:false,
        contactfailed:false,
        apierror:false
    });
    return newState;
  },
  [types.GET_CAMPAIGN_SUCCESS](state,actions){
    const newState = Object.assign({},state,{
        getCampaign:false,
        campaign:actions.campaign,
        fileupload:actions.fileupload,
        fileuploaded:false,
        contactfailed:false
    });
    return newState;
  },
  [types.GET_CAMPAIGN_FAIL](state){
    const newState = Object.assign({},state,{
        getCampaign:false,
        contactfailed:false
    });
    return newState;
  },
  [types.SEND_CAMPAIGN_FAIL](state,actions){
    const newState = Object.assign({},state,{
        getCampaign:false,
        contactfailed:false,
        apierror:actions.message.apierror,
        message:actions.message.message
    });
    return newState;
  },
  [types.POST_CONTACTS_SUCCESS](state,actions){
    const newState = Object.assign({},state,{
      getCampaign:false,
      campaign:actions.campaign,
      fileupload:true,
      fileuploaded:true,
      filename:actions.name,
      contactfailed:false
    });
    return newState;
  },
  [types.POST_CONTACTS_FAIL](state,actions){
    const newState = Object.assign({},state,{
        getCampaign:false,
        fileupload:true,
        fileuploaded:false,
        errormessage:actions.message,
        contactfailed:true
    });
    return newState;
  },
  [types.CREATE_CAMPAIGN_START](state){
    const newState = Object.assign({},state,{
        getCampaign:true,
        fileupload:false,
        fileuploaded:false
    });
    return newState;
  },
  [types.CREATE_CAMPAIGN_SUCCESS](state,actions){
    const newState = Object.assign({},state,{
        getCampaign:false,
        campaign:actions.campaign,
        fileupload:!actions.exit,
        fileuploaded:false,
        apierror:false

    });
    return newState;
  },
  [types.CREATE_CAMPAIGN_FAIL](state){
    const newState = Object.assign({},state,{
        getCampaign:false,
        fileupload:false,
        fileuploaded:false
    });
    return newState;
  },
  [types.DEL_CAMPAIGN_START](state){
    const newState = Object.assign({},state,{
        getOutreach:true,
        fileupload:false,
        fileuploaded:false
    });
    return newState;
  },
  [types.FILE_MODAL_CLOSE](state){
    const newState = Object.assign({},state,{
        fileupload:false,
    });
    return newState;
  },
  [types.DEL_CAMPAIGN_SUCCESS](state,actions){

    let outreaches = state.outreaches;
    console.log("unfiltered",outreaches.campaigns);
    outreaches.campaigns = outreaches.campaigns.filter((campaign)=>{
      return campaign.id !== actions.campaign.id 
    });
    // console.log("filtered",campaigns);
    // outreaches = {outreaches ,...campaigns};
    const newState = Object.assign({},state,{
        getOutreach:false,
        fileupload:false,
        fileuploaded:false,
        outreaches:outreaches
    });
    return newState;
  },
  [types.CREATE_CAMPAIGN_FAIL](state){
    const newState = Object.assign({},state,{
          getOutreach:false,
          fileupload:false,
          fileuploaded:false
    });
    return newState;
  },
  [types.REFRESH_CAMPAIGN](state,actions){
    let outreaches = Object.assign({},state.outreaches); 
    
    outreaches.campaigns = outreaches.campaigns.map((campaign)=>{
      // campaign.id !== actions.campaign.id 
      if(campaign.id === actions.campaign.id ){
        let refreshCount = 1;
        if(campaign.refreshCount){
          console.log("campaign.refreshCount",campaign.refreshCount,refreshCount);
          refreshCount+=campaign.refreshCount
        }
        if(moment(actions.campaign.updated_time).isAfter(campaign.updated_time)){
          actions.campaign.refreshCount = refreshCount;
          campaign = actions.campaign;  
        }else{
          campaign.refreshCount =  refreshCount;
        }
        console.log("campaign.refreshCount",campaign.refreshCount,refreshCount);
      }
      return campaign;
    });
    const newState = Object.assign({},state,{
      outreaches:outreaches,
      refresh:true 
    });
    return newState;
  },
});

export { Outreaches as default };
